import { graphql, useStaticQuery } from "gatsby"
import { useCallback } from "react"

export const useScavengerHunt = () => {
  const { scavengerHunt } = useStaticQuery<GatsbyTypes.SettingScavengerHuntQuery>(graphql`
    query SettingScavengerHunt {
      scavengerHunt: sanitySettingScavengerHunt {
        enabled
        title
        image {
          ...CustomImageFragment
        }
        link {
          ...LinkFragment
        }
        tags
      }
    }
  `)

  const getScavengerHuntFromTags = useCallback(
    (tags?: string[]) => {
      if (!scavengerHunt) {
        return null
      }
      if (tags && tags.length > 0) {
        const hasMatchingTag = scavengerHunt.tags.some(tag => tags.includes(tag))
        return hasMatchingTag ? scavengerHunt : null
      }
      return null
    },
    [scavengerHunt]
  )

  return {
    getScavengerHuntFromTags,
  }
}
